import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { faLink, faTimes } from "@fortawesome/free-solid-svg-icons";
import { CenterContainer, Overlay, PopupWindow } from '../shared/PopupComponents';
import { routes } from '../../data/routes';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { MapDeleteButton } from "./MapDeleteButton";
import { undoableMapEditorCloseCurrentMap } from "../../stores/undo/operation/MapEditorCloseCurrentMapOp";
import { undoableMapEditorDeleteMap } from "../../stores/undo/operation/MapEditorDeleteMapOp";
import { PopupSubMenu, Orientation, PopupSubMenuIconContainer } from "../menu/PopupSubMenu";
import { MenuCardSubLabel } from "../menu/MenuCardSubLabel";
import { undoableMapEditorCreateMap } from "../../stores/undo/operation/MapEditorCreateMapOp";
import { FaPlus } from "react-icons/fa";
import { MenuCard } from "../menu/MenuCard";
import { MapSettingsComponent } from "./MapSettingsComponent";
import { MenuCardLabel } from "../menu/MenuCardLabel";
import { InputWithMargin } from "../editor/Input";
import { editorStore } from "../../stores/EditorStore";
import { BsGearFill } from "react-icons/bs";
import { mainMapEditorStore } from "../../stores/MapEditorStore";
const Row = styled.div.withConfig({
  displayName: "MapOperationsMenu__Row",
  componentId: "sc-4003l8-0"
})(["display:flex;flex-direction:row;margin-left:8px;margin-top:4px;margin-bottom:4px;align-items:center;"]);
const Title = styled.h3.withConfig({
  displayName: "MapOperationsMenu__Title",
  componentId: "sc-4003l8-1"
})(["margin:2px;color:black;"]);
const StyledButton = styled.button.withConfig({
  displayName: "MapOperationsMenu__StyledButton",
  componentId: "sc-4003l8-2"
})(["display:flex;flex-direction:row;flex-shrink:0;margin:2px;cursor:pointer;"]);
const MarginIcon = styled(FontAwesomeIcon).withConfig({
  displayName: "MapOperationsMenu__MarginIcon",
  componentId: "sc-4003l8-3"
})(["margin-right:4px;"]);
export const MapOperationsMenu = observer(({
  openButtonDisabled
}) => {
  const {
    t
  } = useTranslation();
  const {
    currentMap,
    runningMapOperation,
    currentMapId
  } = mainMapEditorStore.currentMapStore;
  const [showURLs, setShowURLs] = React.useState([]);
  const [newMapName, setNewMapName] = useState("");

  const triggerShowURLs = () => {
    const base = location.origin;
    const params = "?map=" + currentMapId;
    setShowURLs([[
    /*t*/
    "editor.open_map_in_map_editor_url", base + routes.editorMap + params], [
    /*t*/
    "editor.open_map_in_game_editor_mode_url", base + routes.editorGame + params] //[/*t*/"editor.open_map_in_game_only_mode_url", base + routes.game + params]
    ]);
  };

  const createNewMap = () => {
    undoableMapEditorCreateMap(newMapName);
    setNewMapName("");
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopupSubMenu, {
    orientation: Orientation.Right,
    relativeOffset: 0.25,
    disabled: openButtonDisabled,
    positionFixed: true,
    containerWidth: "400px",
    buttonContent: /*#__PURE__*/React.createElement(PopupSubMenuIconContainer, null, /*#__PURE__*/React.createElement(BsGearFill, null))
  }, currentMap && (editorStore.isMainGameEditor || currentMap.moduleOwner === editorStore.sessionModuleId) && /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.map") + ": " + currentMap.properties.name), /*#__PURE__*/React.createElement(MenuCardSubLabel, null, t("editor.map_operations")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(StyledButton, {
    onClick: () => undoableMapEditorCloseCurrentMap(mainMapEditorStore.currentMapStore),
    disabled: runningMapOperation || !currentMap
  }, /*#__PURE__*/React.createElement(MarginIcon, {
    icon: faTimes
  }), t("editor.close_map")), /*#__PURE__*/React.createElement(MapDeleteButton, {
    onConfirm: () => undoableMapEditorDeleteMap(currentMapId),
    disabled: runningMapOperation || !currentMap
  }), /*#__PURE__*/React.createElement(StyledButton, {
    onClick: triggerShowURLs,
    disabled: runningMapOperation || !currentMap
  }, /*#__PURE__*/React.createElement(MarginIcon, {
    icon: faLink
  }), t("editor.get_direct_links"))), /*#__PURE__*/React.createElement(MapSettingsComponent, null)), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(Title, null, t("editor.map_create")), /*#__PURE__*/React.createElement(Row, null, t("editor.map_name"), /*#__PURE__*/React.createElement(InputWithMargin, {
    disabled: runningMapOperation,
    type: "text",
    value: newMapName,
    onChange: e => setNewMapName(e.target.value)
  }), /*#__PURE__*/React.createElement(StyledButton, {
    disabled: runningMapOperation || !newMapName,
    onClick: createNewMap
  }, /*#__PURE__*/React.createElement(FaPlus, null), " ", t("editor.create_new_map"))))), (showURLs === null || showURLs === void 0 ? void 0 : showURLs.length) > 0 && /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(PopupWindow, null, showURLs.map(([label, url]) => /*#__PURE__*/React.createElement("div", {
    key: url
  }, t(label), ": ", /*#__PURE__*/React.createElement("a", {
    href: url
  }, url))), /*#__PURE__*/React.createElement("button", {
    onClick: () => setShowURLs([])
  }, "X")))));
});